import { Config } from './typing';

export const config: Config = {
  basename: '/',
  muiLicenseKey:
    '396cb362319abad931532e1eda868d0bTz0xMjgzNTAsRT0xODA4MDkyNzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=',
  oidc: {
    authority: 'https://idp.optocycle.com',
    clientId: '380159163860320701',
    projectId: 'ocdesk-stg',
  },
};
